import Vue from 'vue'
import Vuex from 'vuex'
import zones from './modules/zones.js'
import users from './modules/users.js'
import orders from './modules/orders.js'
import roles from './modules/roles.js'
import reminders from './modules/reminders.js'
import config from './modules/config.js'
import router from '@/router'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    zones,
    users,
    orders,
    reminders,
    roles,
    config
  },
  state: {
    section: {
      index: "0",
      name: '',
    },
    is_mobile: false,
    provinces: ['Buenos Aires', 'CABA', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba', 'Corrientes', 'Entre Ríos', 'Formosa',
                'Jujuy', 'La Pampa', 'La Rioja', 'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta', 'San Juan', 'Santa Cruz',
                'Santa Fe', 'Santiago del Estero', 'Tierra del Fuego', 'Tucumán'
    ],
    current_user: {
      displayName: '',
      role: ''
    },
  },
  mutations: {
    CHANGE_SECTION(state, section) {
      if( section ) {
        state.section.index = section.index
        state.section.name = section.name
      }
    },
    CHANGE_WINDOWS_SIZE(state, size) {
      // If window width is less than 700px then is mobile
      state.is_mobile = size <= 700
    },
    SET_ERROR(state, error) {
      console.error(error)
      // TODO add to DB
    },
    SET_CURRENT_USER( state, user ) {
      state.current_user.displayName = user.displayName ? user.displayName : user.email
      user.getIdTokenResult()
        .then(function ({ claims }) {
          let userPermissions = ''
          if( claims.superUser ) userPermissions = 'superUser'
          else if( claims.admin ) userPermissions = 'admin'
          else if( claims.commercial ) userPermissions = 'commercial'
          else if( claims.driver ) userPermissions = 'driver'
          
          state.current_user.role = userPermissions
        })
    }
  },
  actions: {
  },
  getters: {
    hasPermission: (state) => (sectionName, permissionReq) => {
      const list = router.options.routes.find(e => e.name == 'Admin').children
      const section = list.find( e => e.name == sectionName )
      
      if( section ) {
        const permission = section.meta[state.current_user.role]
        if( permission ) {
          if( permission === 'all' || permission === permissionReq )
            return true
          else if( permission === 'edit' && permissionReq === 'view' )
            return true
          else
            return false
        }
      }
    }
  }
})
